import Layout from "@/ux/layout/Layout.vue";
import HomeView from "../ux/home/HomeView.vue";
import Error404View from "../ux/pageNotFound/Error404View.vue";

export const websiteRoutes = [
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
      },
      {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: Error404View,
      },
    ],
  },
];
